import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'warm' | 'white';
}
export function Section({
  children,
  className = '',
  id,
  background = 'warm'
}: SectionProps) {
  const bgClass = background === 'warm' ? 'bg-[#FFF5F0]/60' : 'bg-white/60';
  return <section id={id} className={`w-full py-16 md:py-24 ${bgClass} ${className}`} data-id="element-253">
      <div className="max-w-3xl mx-auto px-6 md:px-8" data-id="element-254">{children}</div>
    </section>;
}
export function FadeIn({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    delay,
    ease: 'easeOut'
  }} data-id="element-255">
      {children}
    </motion.div>;
}